import { apiGet, apiPut } from '../shared/apiClient';
export async function fetchAddressSettings() {
  const response = await apiGet('/customers/address-settings');
  if (!response.data.success || !response.data.data) throw new Error(response.data.message || 'Address settings unavailable');
  return response.data.data;
}
export async function saveAddressSettings(settings, areas) {
  const response = await apiPut('/customers/address-settings', { expected_version: settings.version, own_delivery_areas: areas });
  if (!response.data.success) throw new Error(response.data.message || 'Could not save delivery areas');
  return response.data.data;
}
